import { Map } from 'immutable';
import simpleReducer from '../common/utils/simple-reducer';
import { addLocale } from './actions';
import { FORM_NAME } from './constants';

const emptyMap = Map();

export default {
  [FORM_NAME]: simpleReducer(emptyMap, {
    [addLocale.FULFILLED](state: any) {
      return state.mergeIn(['data'], {
        language: undefined,
        country: undefined
      });
    }
  })
};
